import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_ACC002_Response,
  IAPI_ACC002_Request,
  IAPI_ACC004_Response,
  IAPI_ACC004_Request,
} from "../../../type/apiType";

// 法人ユーザ更新API
const httpAPI_ACC004 = async (
  param: IAPI_ACC004_Request
): Promise<IAPI_ACC004_Response> => {
  let res = await http.post(ApiUrl.API_ACC004, {
    ...param,
  });

  return res.data;
};

// 法人ユーザ参照API
const httpAPI_ACC002 = async (
  param: IAPI_ACC002_Request
): Promise<IAPI_ACC002_Response> => {
  let res = await http.post(ApiUrl.API_ACC002, {
    ...param,
  });

  return res.data;
};

export { httpAPI_ACC004, httpAPI_ACC002 };
